import { render, staticRenderFns } from "./ServerTasks.vue?vue&type=template&id=179a51af"
import script from "./ServerTasks.vue?vue&type=script&lang=js"
export * from "./ServerTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports